export default __webpack_public_path__ + "static/media/Head_6_Ear_1_C1.b0260bd1.svg";